import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import {
	Observable,
	throwError,
} from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ICommonResponseError } from '../../../Common/@types/core';

@Injectable()
export class AuthenticationMeetingsAuthRedirectInterceptor implements HttpInterceptor {

	intercept (req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(req).pipe(
			catchError((response: ICommonResponseError) => {
				if (response.status === 401 && !localStorage.getItem('isBeingAuthorizedLocally')) {
					window.location.assign(`${ window.location.protocol }//${ window.location.host }${ window.location.pathname }`);
				}

				return throwError(response);
			}),
		);
	}
}
